import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {Auth0Provider} from "./services/auth0";
import {RecoilRoot} from 'recoil';
import * as serviceWorker from './serviceWorker';

const {
    REACT_APP_domain,
    REACT_APP_clientId,
    REACT_APP_audience,
    REACT_APP_scope,
} = process.env;

ReactDOM.render(
    <RecoilRoot>
        <Auth0Provider
            domain={REACT_APP_domain}
            client_id={REACT_APP_clientId}
            redirect_uri={window.location.origin + '/app-loading'}
            audience={REACT_APP_audience}
            useRefreshTokens={true}
            scope={REACT_APP_scope}>
            <App/>
        </Auth0Provider>
    </RecoilRoot>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
